import OpenSeadragon from 'openseadragon';
import initFabricJSOverlay from '../helpers/overlay';
import { fabric } from 'fabric';

export function initFabricOverlay() {
  fabric.Object.prototype.set({
    borderColor: '#22a2f8',
    cornerColor: '#22a2f8',
    cornerStrokeColor: '#22a2f8',
    cornerSize: 10,
    cornerStyle: 'rect',
    transparentCorners: true,
    borderScaleFactor: 1,
  });

  fabric.Canvas.prototype.set({
    perPixelTargetFind: true,
    targetFindTolerance: 5,
  });

  return initFabricJSOverlay(OpenSeadragon, fabric);
}
